import React, { useEffect, useState } from "react";
import { LoginScreen } from "./modules/Login";
import { Sidebar, TopBar } from "./modules/Sidebar";
import * as DeadlinesM from "./modules/Deadlines";
import { getUsers } from "./services/api";
import * as DashboardM from "./modules/Dashboard";
import * as CqcHqM from "./modules/CqcHq";
import * as AuditEngineM from "./modules/AuditEngine";
import * as ActionPlansM from "./modules/ActionPlans";
import * as AdmissionsM from "./modules/Admissions";
import * as WoundCareM from "./modules/WoundCareModule";
import * as SafeguardingM from "./modules/SafeguardingModule";
import * as MedicationChecksM from "./modules/MedicationChecks";
import * as DolsM from "./modules/Dols";
import * as CallLogM from "./modules/CallLog";
import * as ShiftHandoverM from "./modules/ShiftHandover";
import * as WalkaroundsM from "./modules/Walkarounds";
import * as DiningM from "./modules/DiningModule";
import * as CleaningM from "./modules/CleaningModule";
import * as StockM from "./modules/Stock";
import * as FileVaultM from "./modules/FileVaultModule";
import * as PolicyCentreM from "./modules/PolicyCentre";
import * as StaffM from "./modules/Staff";
import * as TrainingM from "./modules/Training";
import * as FeedbackM from "./modules/FeedbackModule";
import * as AuditsM from "./modules/Audits";
import * as ComplianceM from "./modules/ComplianceModule";
import * as CqcReadinessM from "./modules/CqcReadiness";
import * as ReportsM from "./modules/Reports";
import * as SettingsM from "./modules/Settings";
import * as ResidentsM from "./modules/Residents";
import * as IntelligenceM from "./modules/Intelligence";
import * as ReconciliationM from "./modules/Reconciliation";
import { allowedViewsFor, SESSION_TIMEOUT_MS } from "./data/permissions";
import { moduleGuides } from "./data/moduleGuides";
import { restoreFromBackend, syncAllToBackend, logAudit } from "./services/backend";
import * as EvidencePackM from "./modules/EvidencePack";
import * as WellbeingM from "./modules/Wellbeing";
import * as YouSaidWeDidM from "./modules/YouSaidWeDid";
import * as NearMissM from "./modules/NearMiss";
import * as TrendsM from "./modules/Trends";
import * as EndOfLifeM from "./modules/EndOfLife";
import * as McaHubM from "./modules/McaHub";
import * as StaffWellbeingM from "./modules/StaffWellbeing";
import * as PartnershipsM from "./modules/Partnerships";
import * as MedicationSuiteM from "./modules/MedicationSuite";
import * as Resident360M from "./modules/Resident360";
import * as AdmissionsBundleM from "./modules/AdmissionsBundle";
import * as IpcM from "./modules/Ipc";
import * as ScrutinyM from "./modules/Scrutiny";
import * as HardeningM from "./modules/Hardening";
import * as ActivitiesM from "./modules/Activities";
import * as DependencyPricingM from "./modules/DependencyPricing";
import * as DeepAuditM from "./modules/DeepAudit";
import * as DependencyToolM from "./modules/DependencyTool";
import * as EnhancedAdmissionsM from "./modules/EnhancedAdmissions";
import * as MedCompetencyM from "./modules/MedCompetency";
import * as CqcActionPlanM from "./modules/CqcActionPlan";
import * as LifecycleTestM from "./modules/LifecycleTest";
import * as BulkUploadM from "./modules/BulkUpload";
   import * as PcsSyncM from "./modules/PcsSync";
import * as UserGuideM from "./modules/UserGuide";


const USER_KEY = "rc_user";

const pick = (module: any, name: string) => {
  const def = Reflect.get(module, "default");
  return def || module[name];
};

const first = (...vals: any[]) => vals.find(v => v) || null;

const MODULES: Record<string, any> = {
  dashboard: pick(DashboardM, "Dashboard"),
  "evidence-pack": pick(EvidencePackM, "EvidencePack"),
  "you-said-we-did": pick(YouSaidWeDidM, "YouSaidWeDid"),
  wellbeing: pick(WellbeingM, "Wellbeing"),
  "cqc-action-plan": pick(CqcActionPlanM, "CqcActionPlan"),
  "med-competency": pick(MedCompetencyM, "MedCompetency"),
  "bulk-upload": pick(BulkUploadM, "BulkUpload"),
      "lifecycle-test": pick(LifecycleTestM, "LifecycleTest"),
  "enhanced-admissions": pick(EnhancedAdmissionsM, "EnhancedAdmissions"),
  "dependency-tool": pick(DependencyToolM, "DependencyTool"),
  activities: pick(ActivitiesM, "Activities"),
  "dependency-pricing": pick(DependencyPricingM, "DependencyPricing"),
  ipc: pick(IpcM, "Ipc"),
  "deep-audit": pick(DeepAuditM, "DeepAudit"),
  hardening: pick(HardeningM, "Hardening"),"pcs-sync": pick(PcsSyncM, "PcsSync"),
  "user-guide": pick(UserGuideM, "UserGuide"),

  scrutiny: pick(ScrutinyM, "Scrutiny"),
  "admissions-bundle": pick(AdmissionsBundleM, "AdmissionsBundle"),
  "staff-wellbeing": pick(StaffWellbeingM, "StaffWellbeing"),
  partnerships: pick(PartnershipsM, "Partnerships"),
  "medication-suite": pick(MedicationSuiteM, "MedicationSuite"),
  "resident-360": pick(Resident360M, "Resident360"),
  "mca-hub": pick(McaHubM, "McaHub"),
  trends: pick(TrendsM, "Trends"),
  "near-miss": pick(NearMissM, "NearMiss"),
  "cqc-hq": pick(CqcHqM, "CqcHq"),
  deadlines: pick(DeadlinesM, "Deadlines"),
  "audit-engine": pick(AuditEngineM, "AuditEngine"),
  "action-plans": pick(ActionPlansM, "ActionPlans"),
  admissions: pick(AdmissionsM, "Admissions"),
  "wound-care": first(pick(WoundCareM, "WoundCareModule"), pick(WoundCareM, "WoundCare")),
  safeguarding: first(pick(SafeguardingM, "SafeguardingModule"), pick(SafeguardingM, "Safeguarding")),
  "medication-checks": pick(MedicationChecksM, "MedicationChecks"),
  dols: pick(DolsM, "Dols"),
  "call-log": pick(CallLogM, "CallLog"),
  "shift-handover": pick(ShiftHandoverM, "ShiftHandover"),
  walkarounds: pick(WalkaroundsM, "Walkarounds"),
  dining: first(pick(DiningM, "DiningModule"), pick(DiningM, "Dining")),
  cleaning: first(pick(CleaningM, "CleaningModule"), pick(CleaningM, "CleaningChecklist")),
  stock: pick(StockM, "Stock"),
  "file-vault": pick(FileVaultM, "FileVaultModule"),
  policies: pick(PolicyCentreM, "PolicyCentre"),
  residents: pick(ResidentsM, "Residents"),
  intelligence: pick(IntelligenceM, "Intelligence"),
  reconciliation: pick(ReconciliationM, "Reconciliation"),
  staff: pick(StaffM, "Staff"),
  training: pick(TrainingM, "Training"),
  feedback: pick(FeedbackM, "FeedbackModule"),
  audits: pick(AuditsM, "Audits"),
  compliance: first(pick(ComplianceM, "ComplianceModule"), pick(ComplianceM, "ComplianceDashboard")),
  "cqc-readiness": pick(CqcReadinessM, "CqcReadiness"),
  reports: pick(ReportsM, "Reports"),
    settings: pick(SettingsM, "SettingsModule"),
  "end-of-life": pick(EndOfLifeM, "EndOfLife"),
};

const LOGIN_TARGETS = [
  { url: "/api/index.php?action=login", type: "json" },
  { url: "https://admin.roopcottage.co.uk/api/index.php?action=login", type: "json" },
  { url: "https://roopcottage.co.uk/api/index.php?action=login", type: "text" },
  { url: "https://roopcottage.co.uk/api/index.php?action=login", type: "form" },
];

async function postLogin(email: string, password: string): Promise<any> {
  let lastError: any = null;

  for (const target of LOGIN_TARGETS) {
    try {
      const headers: any = {};
      let body: any;

      if (target.type === "json") {
        headers["Content-Type"] = "application/json";
        body = JSON.stringify({ email, password });
      } else if (target.type === "text") {
        headers["Content-Type"] = "text/plain;charset=UTF-8";
        body = JSON.stringify({ email, password });
      } else {
        headers["Content-Type"] = "application/x-www-form-urlencoded";
        body = "email=" + encodeURIComponent(email) + "&password=" + encodeURIComponent(password);
      }

      const res = await fetch(target.url, { method: "POST", credentials: "include", headers, body });
      return await res.json();
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error("Login failed");
}
class ModuleBoundary extends React.Component<{ children: any }, { error: any }> {
  constructor(props: any) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error: any) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="m-6 rounded-xl border-2 border-red-300 bg-red-50 p-6">
          <div className="font-semibold text-red-800">This module hit a data error and was safely stopped - the rest of the system and your session are fine.</div>
          <div className="mt-2 text-sm text-red-700">Usually caused by an incomplete or test record. Go to Lifecycle Test Suite and click "Remove all demo data", then come back to this module.</div>
        </div>
      );
    }
    return this.props.children;
  }
}
export default function App() {
  const [user, setUser] = useState<any>(null);
  const [currentView, setCurrentView] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [ready, setReady] = useState(false);

  const allowed = allowedViewsFor(user);

  useEffect(() => {
    restoreFromBackend().finally(() => setReady(true));
  }, []);

  useEffect(() => {
    if (!user) return undefined;
    syncAllToBackend(user);
    const timer = setInterval(() => syncAllToBackend(user), 30000);
    return () => clearInterval(timer);
  }, [user]);

  useEffect(() => {
    if (!user) return undefined;

    let timer: any = null;

    const reset = () => {
      if (timer) clearTimeout(timer);

      timer = setTimeout(() => {
        localStorage.removeItem(USER_KEY);
        setUser(null);
        setCurrentView("dashboard");
      }, SESSION_TIMEOUT_MS);
    };

    const events = ["click", "keydown", "scroll", "mousemove"];

    events.forEach(name => window.addEventListener(name, reset));
    reset();

    return () => {
      events.forEach(name => window.removeEventListener(name, reset));
      if (timer) clearTimeout(timer);
    };
  }, [user]);

  useEffect(() => {
    if (user && !allowedViewsFor(user).includes(currentView)) {
      setCurrentView("dashboard");
    }
  }, [user, currentView]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(USER_KEY);
      if (stored) setUser(JSON.parse(stored));
    } catch (error) {
      console.error(error);
    }
  }, []);

  const handleLogin = async (email: string, password: string) => {
    const data = await postLogin(email, password);

    if (!data || data.error) {
      throw new Error(data && data.error ? String(data.error) : "Login failed");
    }

    let found = data.user || null;

    if (!found && (data.id || data.email || data.role || data.name)) {
      found = data;
    }

    if (!found) {
      try {
        const users = await getUsers();
        found = users.find((item: any) => String(item.email).toLowerCase() === String(email).toLowerCase()) || null;
      } catch (error) {
        console.error(error);
      }
    }

    if (!found) {
      found = { id: 0, name: email, email, role: "SuperAdmin" };
    }

    localStorage.setItem(USER_KEY, JSON.stringify(found));
    setUser(found);
    logAudit(found, "LOGIN", "auth", found.email || "", "User signed in");
  };

  const handleLogout = () => {
    localStorage.removeItem(USER_KEY);
    setUser(null);
    setCurrentView("dashboard");
    logAudit(user, "LOGOUT", "auth", "", "User signed out");
  };

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  if (!ready) {
    return <div className="flex min-h-screen items-center justify-center bg-[#123B36] text-sm text-white">Loading secure records…</div>;
  }

  if (!user) {
    return <LoginScreen onLogin={handleLogin} />;
  }

  const ActiveModule = MODULES[currentView];

  return (
    <div className="flex min-h-screen bg-slate-100">
      <Sidebar currentView={currentView} onNavigate={setCurrentView} isOpen={sidebarOpen} onToggle={toggleSidebar} user={user} onLogout={handleLogout} allowed={allowed} />
      <div className="flex flex-1 flex-col min-w-0">
        <TopBar user={user} onToggleSidebar={toggleSidebar} />
        <main className="flex-1 overflow-auto">
          {!ActiveModule ? (
            <div className="p-8 text-slate-500">This module is not available in this build.</div>
          ) : allowed.includes(currentView) ? (
            <div>
              {moduleGuides[currentView] ? (
                <details open className="mx-6 mt-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
                  <summary className="cursor-pointer text-sm font-semibold text-slate-900">How to use this module - step by step</summary>
                  <p className="mt-2 text-sm text-slate-600">{moduleGuides[currentView].intro}</p>
                  <ol className="mt-2 list-decimal space-y-1 pl-5 text-sm text-slate-700">
                    {moduleGuides[currentView].steps.map((step, index) => <li key={index}>{step}</li>)}
                  </ol>
                </details>
              ) : null}
                <ModuleBoundary key={currentView}>
                <ActiveModule user={user} />
              </ModuleBoundary>
            </div>
          ) : (
            <div className="p-8 text-slate-500">You do not have permission to view this module.</div>
          )}
        </main>
      </div>
    </div>
  );
}